import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FirebaseContext from "../firebase/firebaseContext";

const StudentItem = () => {
  const firebaseContext = useContext(FirebaseContext);
  const { auth } = firebaseContext;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState("");

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      if (user) {
        setUserId(user.uid);
      }
    });
  }, []);

  const onLogin = e => {
    e.preventDefault();
    firebaseContext.login(email, password);
  };

  return (
    <div>
      <div className='login-container'>
        <h1 className='login-h1'>ONLINE ZVEZEK</h1>
        <p>Učenec si lahko, če želi, ustvari svoj zvezek.</p>
        <p>Zvezek bo viden le učencu in učitelju, ki učenca poučuje</p>
        <p>
          Zvezek ni obvezen. Nudi možnost povratne informacije učencu (komentar
          naloge, ipd.){" "}
        </p>
        <p>Želiš svoj zvezek? Ustvari si ga spodaj.</p>

        <form onSubmit={e => onLogin(e)} className='login-form'>
          <h1>Vpis za obstoječe uporabnike.</h1>
          <input
            type='text'
            className='form-input'
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder='Uporabniško ime'
          />
          <input
            type='text'
            className='form-input'
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder='Geslo'
          />
          <button type='submit' className='login-button'>
            Potrdi
          </button>
          {userId ? (
            <Link to={"/ucenec/" + userId} className='login-vstopi'>
              Vstopi
            </Link>
          ) : (
            <p className='login-vstopi'>Vnesi upor. ime in geslo za vstop</p>
          )}
          <p className='login-info'>
            Uporabniško ime in geslo dobiš tako, da si ustvariš zvezek.
          </p>
        </form>
        <Link to='/register' className='zvezek'>
          USTVARI SI SVOJ ZVEZEK
        </Link>
      </div>
    </div>
  );
};

export default StudentItem;
